import axios from "axios";

const GETDATAPROGRAME_API_BASE_URL =
  "https://doclicapp.herokuapp.com/api/plan/admin";
const DELETEPROGRAME_API_BASE_URL = "https://doclicapp.herokuapp.com/api/plan";
const DUPLIQUER_API_BASE_URL = "https://doclicapp.herokuapp.com/api/plan/clone";
const UPDATE_API_BASE_URL = "https://doclicapp.herokuapp.com/api/plan/update";
class ServiceProgram {
  getdataprograme(adminId) {
    return axios.get(GETDATAPROGRAME_API_BASE_URL + "/" + adminId);
  }

  deleteprograme(id) {
    return axios.delete(DELETEPROGRAME_API_BASE_URL + "/" + id);
  }
  dupliquer(id) {
    return axios.post(DUPLIQUER_API_BASE_URL + "/" + id);
  }
  updatePlan(
    id,
    designation,
    datePlaning,
    capacity,
    timeSL1,
    timeSL2,
    timeSL3,
    timeSL4,
    timeSL5,
    timeSL6,
    timeSL7,
    timeSL8,
    timeSL9,
    timeSL10,
    timeSL11,
    timeSL12,
    timeSL13,
    timeSL14,
    timeSL15,
    timeSL16,
    timeSL17,
    timeSL18,
    timeSL19,
    timeSL20,
    timeSL21,
    timeSL22,
    timeSL23,
    timeSL24,
    timeSL25,
    timeSL26,
    timeSL27,
    timeSL28,
    timeSL29,
    timeSL30,
    timeSL31,
    timeSL32,
    timeSL33,
    timeSL34,
    timeSL35,
    timeSL36,
    timeSL37,
    timeSL38,
    timeSL39,
    timeSL40,
    timeSL41,
    timeSL42,
    timeSL43,
    timeSL44,
    timeSL45,
    timeSL46,
    timeSL47,
    timeSL48,
    typePlan
  ) {
    return axios.put(UPDATE_API_BASE_URL, {
      id,
      designation,
      datePlaning,
      capacity,
      timeSL1,
      timeSL2,
      timeSL3,
      timeSL4,
      timeSL5,
      timeSL6,
      timeSL7,
      timeSL8,
      timeSL9,
      timeSL10,
      timeSL11,
      timeSL12,
      timeSL13,
      timeSL14,
      timeSL15,
      timeSL16,
      timeSL17,
      timeSL18,
      timeSL19,
      timeSL20,
      timeSL21,
      timeSL22,
      timeSL23,
      timeSL24,
      timeSL25,
      timeSL26,
      timeSL27,
      timeSL28,
      timeSL29,
      timeSL30,
      timeSL31,
      timeSL32,
      timeSL33,
      timeSL34,
      timeSL35,
      timeSL36,
      timeSL37,
      timeSL38,
      timeSL39,
      timeSL40,
      timeSL41,
      timeSL42,
      timeSL43,
      timeSL44,
      timeSL45,
      timeSL46,
      timeSL47,
      timeSL48,
      typePlan,
    });
  }
}

export default new ServiceProgram();
